<template>
  <UiCard>
    <div slot="title">
      <div class="title">Данные</div>
    </div>

    <div slot="content">
      <UiFakeInputs />

      <div class="row two-columns between-xs">
        <!-- `fields` находятся в файле './fields.js' -->
        <form-group
          v-for="field in fields"
          :key="field.key"
          :validator="$v.form[field.key]"
          :server-errors="serverError(field.key)"
        >
          <template slot-scope="{ attributes }">
            <component
              :is="field.component"
              v-model.trim="form[field.key]"
              :class="attributes.class"
              v-bind="field.attrs"
              v-on="field.listeners"
            />
          </template>
        </form-group>
      </div>
    </div>

    <div slot="footer">
      <UiButton
        :disabled="tryCreateManager"
        :class="['button', 'is-blue', { 'is-loading': tryCreateManager }]"
        @click="createManager"
      >
        Добавить
      </UiButton>
    </div>
  </UiCard>
</template>

<script>
import UiCard from '@/components/card/UiCard.vue'
import UiButton from '@/components/UiButton.vue'
import UiInputText from '@/components/UiInputText.vue'
import UiFakeInputs from '@/components/UiFakeInputs.vue'

import fields from './fields.js'

import { ManagersService } from '@/services/managers.service'

export default {
  components: {
    UiButton,
    UiInputText,
    UiCard,
    UiFakeInputs,
  },
  mixins: [fields],
  data() {
    return {
      tryCreateManager: false,

      form: {
        name: '',
        surname: '',
        email: '',
        phone: '',
        password: '',
        password_confirmation: '',
      },
    }
  },
  methods: {
    /**
     * Send request to backend for create new manager.
     * Before send run validation check $v.$touch()
     * After send request run router.push() to created manager profile page.
     *
     * @returns {void}
     * */
    async createManager() {
      this.$v.$touch()
      this.clearFormServerErrors()

      if (this.$v.$invalid) return

      this.tryCreateManager = true
      try {
        const { data } = await ManagersService.create(this.form)

        this.$store.commit('toast/NEW', { type: 'success', message: 'Операция выполнена.' })

        await this.$router.push({ name: 'manager-edit', params: { id: data.manager_id } })
      } catch (error) {
        this.formServerErrors = error.formServerErrors
        this.$store.commit('toast/NEW', { type: 'error', message: error.message })
      } finally {
        this.tryCreateManager = false
      }
    },
  },
}
</script>
